import { createStore, applyMiddleware } from "redux"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import promiseMiddleware from "redux-promise"
import thunkMiddleware from "redux-thunk"
import reducers from "./reducers"
import type { TypeEnv } from "../types"
import logger from "../utils/logger"

const myCreateStore = (env: TypeEnv, onRehydrate: () => void) => {
  const rootReducer = persistReducer(
    {
      key: "v2", // Change this prefix to get a brand new storage,
      storage,
      blacklist: ["i18n", "form", "nav", "vg"]
    },
    reducers
  )

  const store = createStore(
    rootReducer,
    applyMiddleware(thunkMiddleware, promiseMiddleware)
  )

  persistStore(store, undefined, () => {
    logger.info("Rehydratation done")
    if (onRehydrate) {
      onRehydrate()
    }
  })

  return store
}

export default myCreateStore



// WEBPACK FOOTER //
// ./src/store/store.js